/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-12 13:33:57
 * @LastEditTime : 2024-01-04 08:55:40
 * @LastEditors  : yangxr
 * @Description  : 皮重任务API
 * @FilePath     : \icps_change\src\api\smart\schedul\tareTask.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/intelligent/tareTank/queryPage'
export const Download = '/icps/system/sign/intelligent/tareTank/exportList'
export const saveOrUpdate = '/icps/system/sign/intelligent/tareTank/saveTareTask'
/*保存皮重任务*/
export function deleteTareTask(data) {
    return request({
        url: '/icps/system/sign/intelligent/tareTank/deleteTareTask',
        method: 'post',
        data
    })
}
/*根据站点获取车辆列表*/
export function queryCarNoByStation(data) {
    return request({
        url: '/icps/system/sign/basics/car/queryCarNoByStation',
        method: 'post',
        data
    })
}